import { useEffect } from 'react'
import dashjs from 'dashjs'
import { fsColors, BASE_URL } from '../../../shared/constants'
import { useAppSelector } from '../../../store/hooks'

const FsDashPlayer = () => {
  const { currentTheme } = useAppSelector((state) => state.currentUser)

  useEffect(() => {
    const player = dashjs.MediaPlayer().create()
    player.initialize(
      // @ts-ignore
      document.querySelector('#videoPlayer'),
      `${BASE_URL}/manifest/`,
      false,
    )
  }, [])

  return (
    <video
      id="videoPlayer"
      controls
      width="100%"
      height="100%"
      style={{
        borderRadius: '4px',
        border: `1px solid ${
          currentTheme === 'light' ? fsColors.fsDarkBlue.primary : fsColors.fsDarkBlue.light
        }`,
      }}
    />
  )
}

export default FsDashPlayer
